// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from 'devextreme' directly)
// 2. For components use `<DXDS.component_name />` (e.g. `<DXDS.Button />`), for instantiation use use `new DXDS.class_name()`

import type DataSource from 'devextreme/data/data_source';
export type { DataSource };
let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export const DXDS: {
  DataSource: typeof DataSource;
} = {} as any;
export function useDataSource() {
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initDataSource();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initDataSource() {
  return Promise.all([
    import('devextreme/data/data_source').then((x) => {
      DXDS.DataSource = x.default;
    }),
  ])
    .finally(() => (_isLoaded = true))
    .catch((e) => (_error = e));
}
